module.exports = __webpack_public_path__ + "img/8-1_05.0964101d.jpg";